module.exports = __webpack_public_path__ + "static/media/A24 International Servicing Site User Guide_7.13.2022.f3cb216d.pdf";